import { useState } from "react";
import { MoreVertical, ShieldOff, ShieldCheck, Flag, Link2 } from "lucide-react";
import api from "../lib/api";
import ReportSheet from "./ReportSheet";

export default function ProfileActionsMenu({ user, isBlocked, onBlockChange, onMessage }) {
  const [open, setOpen] = useState(false);
  const [confirmBlock, setConfirmBlock] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const handle = "@" + (user.username || user.name || "user");

  const doBlock = async () => {
    await api.post(`/users/${user.id}/block`);
    setConfirmBlock(false);
    onBlockChange(true, `${handle} blocked`);
  };
  const doUnblock = async () => {
    setOpen(false);
    await api.delete(`/users/${user.id}/block`);
    onBlockChange(false, `${handle} unblocked`);
  };
  const copyLink = async () => {
    setOpen(false);
    try { await navigator.clipboard.writeText(`${window.location.origin}/u/${user.id}`); onMessage("Profile link copied"); }
    catch { onMessage("Could not copy link"); }
  };

  const Item = ({ onClick, icon: Icon, color, label, testid }) => (
    <button onClick={onClick} data-testid={testid} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-white/5 active:bg-white/10 text-sm text-left">
      <Icon className="w-4 h-4" style={{ color }}/>{label}
    </button>
  );

  return (
    <>
      <button onClick={()=>setOpen(o=>!o)} data-testid="user-menu" aria-label="More options"
        className="p-2 rounded-full bg-white/10 border border-white/20 active:scale-95 flex-shrink-0">
        <MoreVertical className="w-4 h-4"/>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={()=>setOpen(false)} data-testid="user-menu-backdrop"/>
          <div className="absolute right-0 top-11 z-40 w-52 rounded-2xl bg-[#14141E] border border-white/15 overflow-hidden shadow-2xl" data-testid="user-menu-dropdown">
            {isBlocked
              ? <Item onClick={doUnblock} icon={ShieldCheck} color="#22C55E" label={`Unblock ${handle}`} testid="action-unblock"/>
              : <Item onClick={()=>{ setOpen(false); setConfirmBlock(true); }} icon={ShieldOff} color="#FF2A5F" label={`Block ${handle}`} testid="action-block"/>}
            <Item onClick={()=>{ setOpen(false); setShowReport(true); }} icon={Flag} color="#FF7A00" label="Report" testid="action-report"/>
            <Item onClick={copyLink} icon={Link2} color="#00E5FF" label="Copy profile link" testid="action-copy-link"/>
          </div>
        </>
      )}
      {confirmBlock && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 px-6" onClick={()=>setConfirmBlock(false)} data-testid="block-confirm">
          <div className="w-full max-w-sm rounded-3xl bg-[#0B0B12] border border-white/10 p-5" onClick={e=>e.stopPropagation()}>
            <h3 className="font-outfit font-bold text-lg mb-2">Block {handle}?</h3>
            <p className="text-sm text-white/70 mb-5">They won't be able to message you, follow you or comment on your reels. You won't see their reels either. You can unblock anytime from Settings → Blocked Accounts.</p>
            <div className="flex gap-2">
              <button onClick={()=>setConfirmBlock(false)} data-testid="block-cancel" className="flex-1 p-3 rounded-2xl bg-white/10 font-bold">Cancel</button>
              <button onClick={doBlock} data-testid="block-confirm-btn" className="flex-1 p-3 rounded-2xl bg-[#FF2A5F] font-extrabold">Block</button>
            </div>
          </div>
        </div>
      )}
      {showReport && <ReportSheet user={user} onClose={()=>setShowReport(false)}
        onDone={()=>{ setShowReport(false); onMessage("Report submitted. Admin will review it."); }}/>}
    </>
  );
}
